// window.history.scrollRestoration = 'manual';

// Extend DOM prototypes with custom methods
declare global {
  interface HTMLDocument {
    ready(): Promise<Document>;
    safeWidth(): number;
  }

  interface HTMLVideoElement {
    playSafe(): void;
    reset(): void;
  }
}

HTMLDocument.prototype.ready = function () {
  return new Promise((resolve, reject) => {
    if (document.readyState === 'complete') {
      resolve(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document);
      });
    }
  });
};

HTMLDocument.prototype.safeWidth = function () {
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  );
};

HTMLVideoElement.prototype.playSafe = function () {
  try {
    this.play()
      .then(() => {})
      .catch(() => {});
  } catch (err) {}
};

HTMLVideoElement.prototype.reset = function () {
  this.pause();
  try {
    this.currentTime = 0;
  } catch (err) {}
};

export {};
